import React from "react";
import { lazy, memo, Suspense } from "react";

import { IoClose } from "react-icons/io5";
// import socketIO from "socket.io-client";
// const MessengerPanel = lazy(() =>
//   import("../screens/Messenger/messengerPanel/MessengerPanel")
// );

import DashboardMessage from "../../src/screens/Message/DashboardMessage";
import { socketEndpoint, socketId } from "../configs/axiosConfig";

// const ENDPOINT = "https://socket-lokalai-23jul.onrender.com/";
// const ENDPOINT = "http://localhost:6005/";
// const socketId = socketIO(socketEndpoint, { transports: ["websocket"] });

function ChatModal({ onClose }) {
  return (
    <div className="flex flex-col h-full z-[999] border border-dry bg-dry">
      <DashboardMessage socketId={socketId} onClose={onClose} />
      {/* <MessengerPanel socketId={socketId} /> */}
      {/* Top Bar */}
      {/* <div className="bg-red-600 text-white p-4 flex items-center justify-between">
        <span className="font-bold">Messages</span>
        <button
          onClick={onClose}
          className="hover:bg-white hover:text-red-600 p-2 rounded-full transition duration-300"
        >
          <IoClose size={24} />
        </button>
      </div> */}

      {/* Sidebar with user avatars */}
      {/* <div className="flex h-full">
        <div className="w-[70px] bg-drylight flex flex-col items-center py-4 gap-4 overflow-y-auto">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="w-10 h-10 rounded-full bg-gray-400 border-2 border-white"
            />
          ))}
        </div>

        <div className="flex-1 flex items-center justify-center text-gray-400 bg-dry p-4 text-center">
          Select a contact to start a conversation.
        </div>
      </div> */}
    </div>
  );
}

export default ChatModal;
